import { render, staticRenderFns } from "./comp_UserOrderDetail-Complete.vue?vue&type=template&id=44a9f6f6&scoped=true&"
import script from "./comp_UserOrderDetail-Complete.vue?vue&type=script&lang=js&"
export * from "./comp_UserOrderDetail-Complete.vue?vue&type=script&lang=js&"
import style0 from "./comp_UserOrderDetail-Complete.vue?vue&type=style&index=0&id=44a9f6f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a9f6f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VProgressCircular,VRow,VSpacer})
